// Pure-CSS fade-in. framer-motion was dropped here: without AnimatePresence
// its exit animations never ran, and swapping motion.div in after the lazy
// import remounted the whole subtree (duplicate API calls on landing pages).
const AnimationWrapper = ({ children }) => (
  <div
    style={{
      height: "100%",
      overflowY: "auto",
      opacity: 0,
      animation: "fadeIn 0.3s forwards",
    }}
  >
    {children}
    <style>{`
      @keyframes fadeIn {
        to { opacity: 1; }
      }
    `}</style>
  </div>
);

export default AnimationWrapper;
